// extracted by mini-css-extract-plugin
module.exports = {"buttonBorderless":"Button_buttonBorderless__2L2VH","button":"Button_button__3QF_k","disabled":"Button_disabled__2c3jr"};